import {STORAGE} from '../enums/storage';

export const LIB_KEY = 'ng2-webstorage';
export const LIB_KEY_SEPARATOR = '|';
export const LIB_KEY_CASE_SENSITIVE = false;

export const STORAGE_NAMES = {
	[STORAGE.local]: 'local',
	[STORAGE.session]: 'session',
};
